
import Category from "../../../assets/filled/Category.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CategoryIcon({ className, dataTestid = "CategoryIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Category data-testid={dataTestid} className={classes} {...rest} />
  );
}
